var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormFieldLabel',{attrs:{"label":_vm.field.label,"error":_vm.error,"message":_vm.message}},[_c('FormFieldIndex',_vm._g({attrs:{"value":_vm.value,"type":_vm.field.type,"field":_vm.field}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }